export const fileSizeToMB = (fileSize) => {
  if (typeof fileSize !== 'number') {
    // eslint-disable-next-line no-console
    return console.warn('fileSizeToMB: Argument must be of type "Number".')
  }
  return fileSize / 1024 / 1024
}

export const imageLoad = ({ src, onLoad = () => {}, onError = () => {} }) => {
  const image = new Image()

  image.onload = () => {
    onLoad()
  }

  image.onerror = () => {
    onError()
  }
  image.src = src
}
